import ReactDOM from "react-dom";
import React from "react";
import EligibilityWizard from "../components/eligibility-wizard/EligibilityWizard";

const init = () => {
  let mountPoint = document.querySelector("#EligibilityWizard");

  if (mountPoint) {
    /* parse optional data attributes for potential maintenance message*/
    const maintenance = mountPoint.getAttribute("data-maintenance");
    const maintenanceMessageLine1 = mountPoint.getAttribute(
      "data-maintenance-message-line-1"
    );
    const maintenanceMessageLine2 = mountPoint.getAttribute(
      "data-maintenance-message-line-2"
    );

    ReactDOM.render(
      <EligibilityWizard
        maintenance={maintenance}
        maintenanceMessageLine1={maintenanceMessageLine1}
        maintenanceMessageLine2={maintenanceMessageLine2}
      />,
      mountPoint
    );
  }
};

// Init on initial page load
init();
